import React, { useEffect, Suspense } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./fonts/Gilroy-Light.ttf";
import "./fonts/Gilroy-Medium.ttf";
import "react-notifications/lib/notifications.css";
import "./styles.css";
import LocationListener from "./LocationListerner";

// Loading component
const LoadingFallback = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    fontSize: '16px',
    color: '#4C88D3'
  }}>
    Loading...
  </div>
);

// LAZY LOADED SCREENS - Only load when needed
const Justdial = React.lazy(() => import("./Pages/Justdial"));
const Indiamart = React.lazy(() => import("./Pages/Indiamart"));
const InviteVerification = React.lazy(() => import("./Pages/InviteVerification"));
const Zapier = React.lazy(() => import("./Pages/Zapier"));
const Facebook = React.lazy(() => import("./Pages/Facebook"));
const SharedFile = React.lazy(() => import("./Pages/SharedFile"));
const SharedPage = React.lazy(() => import("./Pages/SharedPage"));
const SignUp = React.lazy(() => import("./Pages/SignUp"));
const LinkHandler = React.lazy(() => import("./Pages/LinkHandler"));
const Website = React.lazy(() => import("./Pages/Website"));
const Wordpress = React.lazy(() => import("./Pages/Wordpress"));
const GoogleLeadForm = React.lazy(() => import("./Pages/GoogleLeadForm"));
const GoogleForms = React.lazy(() => import("./Pages/GoogleForms"));
const Typeform = React.lazy(() => import("./Pages/Typeform"));
const TradeIndia = React.lazy(() => import("./Pages/TradeIndia"));
const Housing = React.lazy(() => import("./Pages/Housing"));
const GoogleAds = React.lazy(() => import("./Pages/GoogleAds"));
const Unsubscribe = React.lazy(() => import("./Pages/Unsubscribe"));
const Acres = React.lazy(() => import("./Pages/Acres"));
const MagicBricks = React.lazy(() => import("./Pages/MagicBricks"));
const SharedPageList = React.lazy(() => import("./Pages/SharedPageList"));
const BussinessCard = React.lazy(() => import("./Pages/BussinessCard"));
const SharedInvoiceView = React.lazy(() => import("./Pages/Invoice_web_views/SharedInvoiceView"));
const SharedOrderView = React.lazy(() => import("./Pages/Order_web_views/SharedOrderView"));
const SharedQuotationView = React.lazy(() => import("./Pages/Quotation_web_views/SharedQuotationView"));
const VerifyEmail = React.lazy(() => import("./Pages/verifyEmail"));
const GoogleSheets = React.lazy(() => import("./Pages/GoogleSheets"));
const Login = React.lazy(() => import("./Pages/login/login"));
const OtpVerification = React.lazy(() => import("./Pages/login/otpVerification"));
const DeleteAccount = React.lazy(() => import("./Pages/deleteAccount"));
const Quotation = React.lazy(() => import("./Pages/Quotation"));
const Invoice = React.lazy(() => import("./Pages/Invoice"));
const Order = React.lazy(() => import("./Pages/Order"));
const GoogleCalenders = React.lazy(() => import("./Pages/GoogleCalenders"));
const GoogleMeet = React.lazy(() => import("./Pages/GoogleMeet"));
const GoogleContacts = React.lazy(() => import("./Pages/GoogleContacts"));
const Gmail = React.lazy(() => import("./Pages/Gmail"));
const Wati = React.lazy(() => import("./Pages/Wati"));
const Brevo = React.lazy(() => import("./Pages/Brevo"));
const Wix = React.lazy(() => import("./Pages/Wix"));
const ExporterIndia = React.lazy(() => import("./Pages/ExporterIndia"));
const Pabbly = React.lazy(() => import("./Pages/pabbly"));
const LinkedInIntegration = React.lazy(() => import('./Pages/LinkedInIntegration'));
const ZeptoMail = React.lazy(() => import("./Pages/ZeptoMail"));
const ProductCatalogContainer = React.lazy(() => import("./Pages/ProductCatalogContainer"));
const FbAudienceTestPage = React.lazy(() => import('./Pages/FbAudienceTestPage'));
const Razorpay = React.lazy(() => import("./Pages/Razorpay"));
const OperatorIntegration = React.lazy(() => import("./Pages/OperatorIntegration"));
const AcefoneIntegration = React.lazy(() => import("./Pages/AcefoneIntegration"));
const CallerDeskIntegration = React.lazy(() => import("./Pages/CallerDeskIntegration"));
const DigitalCard = React.lazy(() => import("./Pages/DigitalCard"));
const CustomerLogin = React.lazy(() => import("./Pages/CustomerPortal/CustomerLogin"));
const CustomerDetails = React.lazy(() => import("./Pages/CustomerPortal/CustomerDetails"));
const Webhooks = React.lazy(() => import("./Pages/Webhooks"));
const HtmlPdfRenderer = React.lazy(() => import("./Pages/HtmlPdfRenderer"));
const ApiPdfRenderer = React.lazy(() => import("./Pages/ApiPdfRenderer"));

export default () => {
  return (
    <Router>
      <LocationListener />
      <Suspense fallback={<LoadingFallback />}>
        <Switch>
        <Route path={["/test-pdf-renderer"]} component={HtmlPdfRenderer} />
        <Route path={["/api-pdf-renderer"]} component={ApiPdfRenderer} />
        <Route path={["/Quotation/:user_id"]} component={Quotation} />
        <Route path={["/invoice/:user_id"]} component={Invoice} />  
        <Route path={["/order/:user_id"]} component={Order} />  
        <Route path={["/quotation/:user_id"]} component={Quotation} />  
        <Route path={["/integration/justdial/:user_id"]} component={Justdial} />
        <Route path={["/invitation"]} component={InviteVerification} />
        <Route path={["/share/invoice/:uniqueLinkId"]} component={SharedInvoiceView} />
        <Route path={["/share/order/:uniqueLinkId"]} component={SharedOrderView} />
        <Route path={["/share/quotation/:uniqueLinkId"]} component={SharedQuotationView} />
        <Route path={["/share/Card/:uniqueLinkId"]} component={DigitalCard} />
        <Route
          path={["/integration/indiamart/:user_id"]}
          component={Indiamart}
        />
        <Route path="/integration/fbaudience" component={FbAudienceTestPage} />

        <Route path={["/integration/razorpay/:user_id"]} component={Razorpay} />
        <Route path={["/integration/housing/:user_id"]} component={Housing} />
        <Route
          path={["/integration/GoogleAds/:user_id"]}
          component={GoogleAds}
        />
        <Route path={["/integration/99acres/:user_id"]} component={Acres} />
        <Route
          path={["/integration/magic_bricks/:user_id"]}
          component={MagicBricks}
        />
          <Route
          path={["/integration/my_operator/:user_id"]}
          component={OperatorIntegration}
        />
        <Route
          path={["/integration/acefone/:user_id"]}
          component={AcefoneIntegration}
        />
        <Route
          path={["/integration/caller_desk/:user_id"]}
          component={CallerDeskIntegration}
        />
        <Route path={["/integration/zapier/:user_id"]} component={Zapier} />
        <Route path={["/integration/facebook/:user_id"]} component={Facebook} />
        <Route
          path={["/integration/wordpress/:user_id"]}
          component={Wordpress}
        />

<Route
          exact // Use exact to ensure it only matches this specific path
          path="/integration/linkedin"
          component={LinkedInIntegration}
        />
        
        <Route path={["/integration/zeptomail/:user_id"]} component={ZeptoMail} />
        <Route path={["/product-share/:uniqueShareId"]} component={ProductCatalogContainer} />
       <Route
  path={["/integration/linkedin/:user_id"]}
  component={LinkedInIntegration}
/>
        <Route path={["/integration/website/:user_id"]} component={Website} />
        <Route
          path={["/integration/google_lead_form/:user_id"]}
          component={GoogleLeadForm}
        />
        <Route
          path={["/integration/google_meet/:user_id"]}
          component={GoogleMeet}
        />
        <Route
          path={["/integration/google_calendar/:user_id"]}
          component={GoogleCalenders}
        />
        <Route
          path={["/integration/google_contacts/:user_id"]}
          component={GoogleContacts}
        />
        <Route path={["/integration/google_mail/:user_id"]} component={Gmail} />
        <Route
          path={["/integration/google_forms/:user_id"]}
          component={GoogleForms}
        />
        <Route
          path={["/integration/tradeIndia/:user_id"]}
          component={TradeIndia}
        />
        <Route path={["/integration/wati/:user_id"]} component={Wati} />
        <Route path={["/integration/brevo/:user_id"]} component={Brevo} />
        <Route path={["/integration/wix/:user_id"]} component={Wix} />
        <Route
          path={["/integration/exporter_india/:user_id"]}
          component={ExporterIndia}
        />
        <Route path={["/integration/typeform/:user_id"]} component={Typeform} />
        <Route
          path={["/integration/google_spread_sheets/:user_id/"]}
          component={GoogleSheets}
        />
        <Route path={["/integration/pabbly/:user_id"]} component={Pabbly} />
        <Route path={["/file/:uniqueLinkId"]} component={SharedFile} />
        <Route path={["/page/:uniqueLinkId"]} component={SharedPage} />
        <Route path={["/pageList/:uniqueLinkId"]} component={SharedPageList} />
        <Route path={["/invite/:userIdEnc"]} component={SignUp} />
        <Route path={["/bussinessCard"]} component={BussinessCard} />
        <Route path={["/quotation/:user_id"]} component={Quotation} />
        <Route path="/verify-email/:token" component={VerifyEmail} />
        <Route path="/delete-account" component={DeleteAccount} />
        <Route path="/lead" component={LinkHandler} />
        <Route path="/unsubscribe/:code" component={Unsubscribe} />
        <Route path="/user-login" component={Login} />
        <Route path="/otp-verify" component={OtpVerification} />
        <Route path="/customer-portal/login" component={CustomerLogin} />
        <Route path="/customer-portal/details" component={CustomerDetails} />
        <Route path={["/integration/three_sigma_webhook/:user_id"]} component={Webhooks} />
        </Switch>
      </Suspense>
    </Router>
  );
};
